// extracted by mini-css-extract-plugin
module.exports = {"giftCardSuccess":"QTL6X","successText":"ebsrX","giftCardButtonDiv":"dBNvz","giftCardSuccessButton":"UZReA"};